{/* TODO: Frank to finalize copy before launch — current text is a generic placeholder */}
import { PublicNav } from "@/components/website/PublicNav";
import { PublicFooter } from "@/components/website/PublicFooter";
import { PublicLayout } from "@/components/website/PublicLayout";
import { useAppSettings } from "@/hooks/useAppSettings";

export default function TermsPage() {
  const { data: settings } = useAppSettings();
  const businessName = settings?.site_logo_text
    ? `${settings.site_logo_text} ${settings.site_logo_subtitle ?? ""}`.trim()
    : "Tristano's Catering";
  const email = settings?.business_email || "info@tristanoscatering.ca";
  const lastUpdated = "April 2026";

  return (
    <PublicLayout className="min-h-screen bg-background flex flex-col">
      <PublicNav />

      <main id="main-content" className="flex-1">
        {/* Hero */}
        <div className="bg-primary py-12 md:py-16">
          <div className="max-w-3xl mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-logo font-bold text-primary-foreground">
              Terms of Service
            </h1>
            <p className="mt-2 text-primary-foreground/80 text-sm font-secondary">
              Last updated: {lastUpdated}
            </p>
          </div>
        </div>

        {/* Body */}
        <article className="max-w-3xl mx-auto px-4 py-10 md:py-14 font-secondary text-foreground/90 space-y-6 leading-relaxed">
          <p>
            These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the {businessName}
            {" "}website and the catering services you may order through it. By using the site
            or placing an order, you agree to these Terms. If you don&rsquo;t agree, please
            don&rsquo;t use the site.
          </p>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              1. Who we are
            </h2>
            <p>
              This website is operated by {businessName} in Ontario, Canada. You can reach us
              at{" "}
              <a className="underline hover:text-primary" href={`mailto:${email}`}>
                {email}
              </a>
              .
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              2. Ordering and quotes
            </h2>
            <p>
              Menu items, packages, and prices shown on the site are for planning purposes.
              A binding order or booking only exists once we have confirmed it in writing
              (email, quote, or invoice) and received any required deposit. We reserve the
              right to decline or cancel an order, for example where a date cannot be
              accommodated, where information appears incorrect, or where suspected fraud is
              involved.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              3. Pricing, taxes, and payment
            </h2>
            <p>
              Prices are in Canadian dollars (CAD) and do not include applicable taxes unless
              stated otherwise. Deposits, final balances, and cancellation timelines will be
              noted on your quote or invoice. Online payments are processed securely by our
              third-party payment processor.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              4. Changes and cancellations
            </h2>
            <p>
              Guest counts, menu selections, and event details can usually be adjusted up to
              a cutoff date specified on your quote. Cancellations made after that cutoff may
              forfeit some or all of the deposit, because food is ordered, prepared, and staff
              is scheduled in advance.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              5. Allergies and dietary needs
            </h2>
            <p>
              We prepare food in kitchens that handle common allergens including gluten, dairy,
              eggs, soy, nuts, and shellfish. We do our best to accommodate dietary
              restrictions when you tell us in advance, but we cannot guarantee a completely
              allergen-free environment. It is your responsibility to communicate serious
              allergies and to make an informed decision.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              6. Intellectual property
            </h2>
            <p>
              All content on this site — including photographs, menus, logos, and written copy
              — belongs to {businessName} or our licensors. You may view and share it for
              personal, non-commercial purposes. Any other use requires our written
              permission.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              7. Limitation of liability
            </h2>
            <p>
              To the maximum extent permitted by law, {businessName} is not liable for
              indirect, incidental, or consequential damages arising out of your use of the
              site. Our total liability for any claim connected to an order is limited to the
              amount you actually paid for that order.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              8. Governing law
            </h2>
            <p>
              These Terms are governed by the laws of the Province of Ontario and the federal
              laws of Canada that apply there, without regard to conflict-of-law principles.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-logo font-semibold text-foreground">
              9. Changes to these Terms
            </h2>
            <p>
              We may update these Terms from time to time. Material changes will be posted on
              this page with an updated date. Continued use of the site after changes are
              posted means you accept the updated Terms.
            </p>
          </section>
        </article>
      </main>

      <PublicFooter />
    </PublicLayout>
  );
}
